// extracted by mini-css-extract-plugin
export default {"container":"Register_container__etO78","form":"Register_form__atjkw","form__button":"Register_form__button__5fYjR","link":"Register_link__hW6AM"};